import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-side-navigation-layout',
  templateUrl: './side-navigation-layout.component.html',
})
export class SideNavigationLayoutComponent implements OnInit, OnDestroy {

  private contentFormPadded!: boolean;
  private routeSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(private responsive: BreakpointObserver, protected router: Router) {
    this.routeSubscription = router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        if(val.url.startsWith('/usan/forms')) {
          this.contentFormPadded = false;
        } else {
          this.contentFormPadded = true;
        }
      }
    });
  }
  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
}

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.sizeChangeSubscription.unsubscribe();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  public useContentFormPadded(): boolean {
    return this.contentFormPadded;
  }

}
